import { vuexfireMutations } from 'vuexfire'

export const mutations = {
  ...vuexfireMutations,

  updatePhoneNumber(state, { phoneNumber }) {
    state.phoneNumber = phoneNumber
  },
  updateVerCode(state, { verCode }) {
    state.verCode = verCode
  },
  updateUserId(state, { userID }) {
    state.userID = userID
  },
  updateTimeBuffer(state, { timeBuffer }) {
    state.timeBuffer = timeBuffer
  },
  updatePaymentEnabled(state, { paymentEnabled }) {
    state.paymentEnabled = paymentEnabled
  },
  updateNotificationChecked(state, { notificationChecked }) {
    // ログインで notification.permissionがチェックされたフラグ
    state.notificationChecked = notificationChecked
  }
}

export const state = () => ({
  phoneNumber: '',
  verCode: '',
  userID: '',
  timeBuffer: '',
  paymentEnabled: undefined,
  notificationChecked: false
})
